module.exports = __webpack_public_path__ + "static/media/icon-sunrise.766edcf9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon-sunrise.svg
// module id = 1345
// module chunks = 0